import { Button } from "@/components/ui/button";
import { FormattedMessage } from "react-intl";

export default function Pagination({
  page,
  pageCount,
  onPageChange,
}: {
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
}) {
  return (
    <div className="flex items-center justify-end gap-2 border-t border-border px-4 py-3 text-sm">
      <Button
        variant="outline"
        size="sm"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        <FormattedMessage id="table.pagination.previous" />
      </Button>
      <span className="text-muted-foreground">
        {page} / {pageCount}
      </span>
      <Button
        variant="outline"
        size="sm"
        disabled={page >= pageCount}
        onClick={() => onPageChange(page + 1)}
      >
        <FormattedMessage id="table.pagination.next" />
      </Button>
    </div>
  );
}
